<div class="loader-wrapper">
    <app-loader [isBusy]="isBusy">
        <ng-template>
            <kendo-grid
                [data]="itemsGridView"
                [skip]="itemPage.skip"
                [pageSize]="itemPage.pageSize"
                [pageable]="pagingOptions"
                [resizable]="true"
                [sortable]="{ allowUnsort: allowUnsort, mode: multiple ? 'multiple' : 'single' }"
                [sort]="sort"
                (pageChange)="pageChange($event, remarks)"
                (sortChange)="sortChange($event, remarks)">
                @if (allowedInsertRemark && hasPermission('PcsApprovals.PcsApprovals.Edit')) {
                    <ng-template kendoGridToolbarTemplate>
                        <button
                            class="btn btn-sm btn-primary"
                            kendoTooltip
                            title="{{ 'Add' | translate }}"
                            [disabled]="isOnlyWatcher"
                            (click)="openNewRemarkDialog()">
                            <fa-icon icon="plus"></fa-icon>
                        </button>
                    </ng-template>
                }
                @if (hasPermission('PcsApprovals.PcsApprovals.Edit')) {
                    <kendo-grid-command-column title="" sortable="false" [width]="80">
                        <ng-template kendoGridCellTemplate let-row>
                            <button
                                class="btn btn-xs btn-danger"
                                kendoTooltip
                                title="{{ 'Remove' | translate }}"
                                [disabled]="
                                    currentDocumentStatus.name !== row.pcsDocumentAndApprovalStatus.name ||
                                    !belongsToOrganization(row.organizationOfCreatedBy)
                                "
                                (click)="openRemoveRemarkDialog(row.id)">
                                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                            </button>
                        </ng-template>
                    </kendo-grid-command-column>
                }
                <kendo-grid-column title="{{ 'Remark' | translate }}" field="remark" [width]="400"></kendo-grid-column>
                <kendo-grid-column title="{{ 'Created On Status' | translate }}" [width]="100">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.pcsDocumentAndApprovalStatus) {
                            <span>
                                {{
                                    row.pcsDocumentAndApprovalStatus.localizedCode +
                                        ' - ' +
                                        row.pcsDocumentAndApprovalStatus.name
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Created By' | translate }}" [width]="200">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.createdBy) {
                            <span>{{ row.createdBy.firstName + ' ' + row.createdBy.lastName }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{ 'Created Date' | translate }}" [width]="250">
                    <ng-template kendoGridCellTemplate let-row>
                        @if (row.createdDate) {
                            <span>{{ row.createdDate | date: 'dd.MM.yyyy HH:mm' }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
                <!--
        ===== This has been removed because Editing button was also removed =====
        ===== Code for last modification left in if it ever needs to be re-enabled =====
        <kendo-grid-column title="{{ 'Last Modified By' | translate }}">
          <ng-template kendoGridCellTemplate let-row>
            <span *ngIf="row.lastModifiedBy"> {{ row.lastModifiedBy.firstName + ' ' + row.lastModifiedBy.lastName }} </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="{{ 'Last Modified Date' | translate }}">
          <ng-template kendoGridCellTemplate let-row>
            <span *ngIf="row.lastModifiedDate">{{ row.lastModifiedDate | date: 'dd.MM.yyyy HH:mm' }}</span>
          </ng-template>
        </kendo-grid-column>
        -->
                <ng-template kendoGridNoRecordsTemplate>
                    <p>{{ 'No records available' | translate }}.</p>
                </ng-template>
            </kendo-grid>
        </ng-template>
    </app-loader>
</div>

@if (newRemarkDialogOpened && !isOnlyWatcher) {
    <kendo-dialog title="{{ 'Add Remark' | translate }}" [minWidth]="550" (close)="closeNewRemarksDialog()">
        <div class="row">
            <span>{{ 'Remark: ' | translate }}</span>
        </div>
        <div class="row">
            <kendo-textarea #remarkTextArea [rows]="3"></kendo-textarea>
        </div>
        <kendo-dialog-actions layout="end">
            <button class="btn btn-sm btn-primary mr-2" preventMultiClick kendoButton (click)="submitNewRemark()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ 'Submit' | translate }}
            </button>
            <button class="btn btn-sm btn-secondary" kendoButton (click)="closeNewRemarksDialog()">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
}

@if (removeRemarkDialogOpened) {
    <kendo-dialog title="{{ 'Remove Remark' | translate }}" [minWidth]="350" (close)="closeRemoveRemarkDialog()">
        <div class="row">
            <span>{{ 'Are you sure you want to remove this remark?' | translate }}</span>
        </div>
        <kendo-dialog-actions layout="end">
            <button class="btn btn-sm btn-primary mr-2" kendoButton (click)="submitRemoveRemark()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ 'Submit' | translate }}
            </button>
            <button class="btn btn-sm btn-secondary" kendoButton (click)="closeRemoveRemarkDialog()">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
}
